var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * ShieldLock component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconShieldLock extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.5 3.27982C2.5 3.15705 2.55844 2.96869 2.75141 2.68885C2.95867 2.56587 3.14562 2.5 3.27982 2.5H20.4904C20.6217 2.5 20.828 2.56686 21.1411 2.79372C21.2824 2.94861 21.3658 3.13563 21.3658 3.37544V8.06053C21.3658 10.9532 20.4646 13.6749 18.9172 16.0478C17.1939 18.3997 14.8457 20.2067 12.2372 21.2064C12.0011 21.2596 11.7691 21.2596 11.533 21.2064C8.9172 20.2039 6.57198 18.3931 4.94822 16.0477C3.3193 13.6948 2.5 10.8816 2.5 8.06053V3.27982ZM3.27982 1C2.67193 1 2.13624 1.29229 1.81204 1.50842C1.7413 1.55558 1.67909 1.61443 1.62807 1.68246C1.30891 2.108 1 2.65264 1 3.27982V8.06053C1 11.1675 1.90175 14.2824 3.71493 16.9015C5.5241 19.5147 8.13345 21.5213 11.0454 22.6258C11.0729 22.6362 11.101 22.645 11.1295 22.6522C11.6314 22.7776 12.1388 22.7776 12.6407 22.6522C12.6692 22.645 12.6973 22.6362 12.7248 22.6258C15.6383 21.5207 18.2405 19.5161 20.1398 16.9171C20.1474 16.9066 20.1548 16.8959 20.1619 16.885C21.8588 14.2898 22.8658 11.2805 22.8658 8.06053V3.37544C22.8658 2.67763 22.5801 2.10979 22.168 1.69774C22.143 1.67265 22.1161 1.64936 22.0877 1.62807C21.6622 1.30891 21.1175 1 20.4904 1H3.27982ZM9.9574 8.17123H13.8118V7.58292C13.8118 6.46731 13.0002 5.65572 11.8846 5.65572C10.7863 5.65572 9.9574 6.54535 9.9574 7.58292V8.17123ZM15.3118 7.58292V8.30307C16.105 8.59585 16.65 9.34704 16.65 10.2598V14.2756C16.65 15.4547 15.7405 16.3642 14.5614 16.3642H9.20703C8.0279 16.3642 7.11843 15.4547 7.11843 14.2756V10.2598C7.11843 9.34676 7.66378 8.59538 8.4574 8.30279V7.58292C8.4574 5.75206 9.9232 4.15572 11.8846 4.15572C13.8286 4.15572 15.3118 5.63888 15.3118 7.58292ZM9.2074 9.67151L9.19254 9.67137C8.84979 9.67783 8.61843 9.91398 8.61843 10.2598V14.2756C8.61843 14.6263 8.85633 14.8642 9.20703 14.8642H14.5614C14.9121 14.8642 15.15 14.6263 15.15 14.2756V10.2598C15.15 9.91411 14.9188 9.67801 14.5763 9.67138L14.5618 9.67151H9.2074ZM12.9365 12.2676C12.9365 12.8485 12.4656 13.3194 11.8848 13.3194C11.3039 13.3194 10.833 12.8485 10.833 12.2676C10.833 11.6868 11.3039 11.2159 11.8848 11.2159C12.4656 11.2159 12.9365 11.6868 12.9365 12.2676Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconShieldLock.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconShieldLock.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconShieldLock.prototype, "size", void 0);
if (customElements.get('cat-icon-shield-lock') === undefined) {
    customElements.define('cat-icon-shield-lock', BlocksIconShieldLock);
}
